import script from "./Page3.vue?vue&type=script&setup=true&lang=js"
export * from "./Page3.vue?vue&type=script&setup=true&lang=js"

import "./Page3.vue?vue&type=style&index=0&id=621663ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621663ef"]])

export default __exports__